import { Box, Typography, Button, useTheme } from "@mui/material";
import {
  PopUpTechDataAndContactRoot,
  PopUpTechDataAndContactHeader,
  PopUpTechDataAndContactContent,
} from "./PopUpTechDataAndContact.styles";
import { TechDataTable } from "../TechDataTable";
import { ShareConfigCode } from "../ShareConfigCode";
import { LanguageSwitch } from "../LanguageSwitch";
import LaunchIcon from "@mui/icons-material/Launch";
import CloseIcon from "@mui/icons-material/Close";
import technicalDataImg from "../../assets/technical_data.png";
import { useSelectedOptions } from "../../context/SelectedOptionsContext";

const CONTACT_LINK = "https://www.switchboombang.com/kontakt";

export const PopUpTechDataAndContact = ({ onHandleClose }) => {
  const { currentTranslations } = useSelectedOptions();
  const theme = useTheme();

  return (
    <PopUpTechDataAndContactRoot>
      <LanguageSwitch sx={{ right: { xs: 50, lg: 70 }, top: 10 }} />
      <Button
        variant="text"
        sx={{
          position: "fixed",
          zIndex: 9,
          top: 0,
          right: { xs: "-10px", md: "-5px" },
          color: theme?.palette?.companyColors?.secondary,
          transition: "all 0.3s ease",
        }}
        onClick={() => {
          onHandleClose(false, "click");
        }}
      >
        <CloseIcon
          sx={{
            padding: "3px 0 0",
            fontSize: "3.5rem",
          }}
        />
      </Button>
      <PopUpTechDataAndContactHeader>
        <Typography
          variant="h3"
          sx={{
            fontWeight: 500,
            flex: 1,
            fontSize: { xs: "2.5rem", lg: "3rem" },
          }}
        >
          {currentTranslations?.contactPopUp?.techData?.title}
        </Typography>
      </PopUpTechDataAndContactHeader>
      <PopUpTechDataAndContactContent dense>
        <Box
          sx={{
            position: "relative",
            width: "100%",
            flex: 1.3,
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
            padding: { xs: "1rem 0", lg: "1rem 2rem 1rem 0" },
            "@media (orientation: portrait)": {
              flexDirection: "column",
            },
          }}
        >
          <Box
            component="img"
            src={technicalDataImg}
            alt={currentTranslations?.contactPopUp?.techData?.title}
            sx={{
              width: "35rem",
              "@media (orientation: portrait)": {
                width: "25rem",
              },
            }}
          />
          <Box
            sx={{
              width: "50%",
              "@media (orientation: portrait)": {
                width: "100%",
              },
            }}
          >
            <TechDataTable />
          </Box>
        </Box>
        <Box
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "flex-start",
            width: "100%",
          }}
        >
          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              position: "relative",
              padding: { xs: "3rem 1rem", lg: "2rem 3rem" },
              gap: { xs: "1.5rem", lg: 0 },
              "@media (orientation: portrait)": {
                flexDirection: "column",
              },
              "&:after": {
                content: "''",
                display: "block",
                width: "100%",
                height: "1px",
                position: "absolute",
                top: 0,
                left: 0,
                background: theme?.palette?.companyColors?.darkGrey3,
              },
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start",
              }}
            >
              <Typography
                variant="h4"
                sx={{
                  fontWeight: 700,
                  flex: 1,
                  mb: { xs: "0.5rem", lg: "1.5rem" },
                  fontSize: { xs: "2.25rem", lg: "2rem" },
                }}
              >
                {currentTranslations?.contactPopUp?.share?.title}
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontWeight: 400,
                  flex: 1,
                  fontSize: { xs: "1.6rem", lg: "1.4rem" },
                  mb: { xs: "0.5rem", lg: "1.5rem" },
                }}
              >
                {currentTranslations?.contactPopUp?.share?.copyText}
              </Typography>
            </Box>
            <ShareConfigCode />
          </Box>
          <Box
            sx={{
              position: "relative",
              width: "100%",
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              padding: { xs: "3rem 1rem", lg: "2rem 3rem" },
              gap: { xs: "1.5rem", lg: 0 },
              "@media (orientation: portrait)": {
                flexDirection: "column",
                alignItems: "flex-start",
              },
              "&:after": {
                content: "''",
                display: "block",
                width: "100%",
                height: "1px",
                position: "absolute",
                top: 0,
                left: 0,
                background: theme?.palette?.companyColors?.darkGrey3,
              },
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start",
              }}
            >
              <Typography
                variant="h4"
                sx={{
                  fontWeight: 700,
                  flex: 1,
                  mb: { xs: "0.5rem", lg: "1.5rem" },
                  fontSize: { xs: "2.25rem", lg: "2rem" },
                  alignSelf: "flex-start",
                }}
              >
                {currentTranslations?.contactPopUp?.contact?.title}
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontWeight: 400,
                  flex: 1,
                  fontSize: { xs: "1.6rem", lg: "1.4rem" },
                }}
              >
                {currentTranslations?.contactPopUp?.contact?.text}
              </Typography>
            </Box>
            <Button
              href={CONTACT_LINK}
              endIcon={<LaunchIcon />}
              target="_blank"
              rel="noreferrer"
              sx={{
                color: theme?.palette?.companyColors?.secondary,
                background: theme?.palette?.companyColors?.accent,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: theme?.borderRadius?.small,
                padding: { xs: "0.75rem 2rem", xl: "0.75rem 5rem" },
                minWidth: "285px",
                height: "45px",
                "@media (orientation: portrait)": {
                  width: "100%",
                },
              }}
            >
              <Typography
                variant="button"
                sx={{
                  textTransform: "initial",
                  fontSize: { xs: "1.85rem", lg: "1.5rem" },
                  fontWeight: 400,
                  textAlign: "center",
                }}
              >
                {currentTranslations?.contactPopUp?.contact?.buttonLink}
              </Typography>
            </Button>
          </Box>
        </Box>
      </PopUpTechDataAndContactContent>
    </PopUpTechDataAndContactRoot>
  );
};
